var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.link.url,"target":_vm.link.target}},[_vm._v(" "+_vm._s(_vm.link.link || _vm.link.title)+" "),(_vm.isExternal(_vm.link.url))?_c('i',{staticClass:"far fa-external-link-alt"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }